import React, { useRef, useState } from "react";
import { Modal, Nav, Tab, ListGroup, Button } from "react-bootstrap";
import { Link } from "react-scroll";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import STRINGS from "../../constants/strings";
import ProductRow from "../ProductRow/index";
import AttributeIconIndex from "../../components/AttributeIconIndex";
import "./styles.scss";
import { isInViewport } from "../../helper";

export default function OrderSelectionModal(props) {
  const scroller = useRef(null);
  const {
    selectedCategory,
    products,
    open,
    closeModal,
    addToCart,
    cart,
    isMobile,
    showPriceValue,
  } = props;
  const [mouseDown, setMouseDown] = useState(null);
  const [clientXMouseDown, setClientXMouseDown] = useState(null);
  const [activeKey, setActiveKey] = useState(
    products &&
      products["sub_categories"] &&
      products["sub_categories"].length > 0
      ? products["sub_categories"][0]
      : null
  );
  const scrollable = isMobile
    ? products &&
      products["sub_categories"] &&
      products["sub_categories"].length > 2
    : products &&
      products["sub_categories"] &&
      products["sub_categories"].length > 8;

  const handleDesktopSwipStart = (event) => {
    if (!mouseDown) {
      setClientXMouseDown(event.clientX);
      setMouseDown(true);
    }
  };

  const handleDesktopSwipEnd = (event, index) => {
    const { clientX } = event;
    if (event.clientX < clientXMouseDown && clientXMouseDown - clientX > 75) {
      if (index + 1 < products["sub_categories"].length) {
        setActiveKey(products["sub_categories"][index + 1]);
      }
    }
    if (clientX > clientXMouseDown && clientX - clientXMouseDown > 75) {
      if (index - 1 >= 0) {
        setActiveKey(products["sub_categories"][index - 1]);
      }
    }
    setMouseDown(null);
  };

  const handleMobileSwipStart = (event) => {
    if (event.touches && event.touches.length > 0) {
      if (!mouseDown) {
        setClientXMouseDown(event.touches[0].clientX);
        setMouseDown(true);
      }
    }
  };

  const handleMobileSwipEnd = (event, index) => {
    if (event.changedTouches && event.changedTouches.length > 0) {
      const { clientX } = event.changedTouches[0];
      if (clientX < clientXMouseDown && clientXMouseDown - clientX > 150) {
        if (index + 1 < products["sub_categories"].length) {
          setActiveKey(products["sub_categories"][index + 1]);
        }
      }
      if (clientX > clientXMouseDown && clientX - clientXMouseDown > 150) {
        if (index - 1 >= 0) {
          setActiveKey(products["sub_categories"][index - 1]);
        }
      }
      setMouseDown(null);
    }
  };

  return (
    <Modal show={open} onHide={closeModal} scrollable keyboard>
      <Modal.Header className={`d-block ${isMobile ? "pt-0 pr-0 pl-0" : ""}`}>
        <Modal.Title
          className={`${
            isMobile
              ? "p-2 text-center"
              : "align-items-center d-flex text-nowrap"
          }`}
        >
          {selectedCategory["category_name"]}
        </Modal.Title>
        <div
          className={`${
            isMobile ? "d-block" : "d-flex justify-content-between"
          }`}
        >
          <AttributeIconIndex isMobile={isMobile} />
          {cart && cart.length > 0 ? (
            <div className="modal-button-container d-flex">
              <div className="modal-button">
                <Link to="product-pricing" smooth={true} offset={-200}>
                  <Button
                    variant="outline-warning"
                    className="landing-button"
                    onClick={closeModal}
                  >
                    View Estimate
                  </Button>
                </Link>
              </div>
              <div className="modal-button">
                <Link to="order-section" smooth={true} offset={-200}>
                  <Button
                    variant="outline-warning"
                    className="landing-button"
                    onClick={closeModal}
                  >
                    {STRINGS.SHOP_MORE_ITEMS}
                  </Button>
                </Link>
              </div>
              <GrClose
                className="pointer align-self-center mr-2"
                size={25}
                onClick={closeModal}
              />
            </div>
          ) : (
            <div className="d-flex justify-content-end mt-2 mr-2">
              <GrClose size={25} className="pointer" onClick={closeModal} />
            </div>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          <p className="text-break">
            {selectedCategory["category_description"]}
          </p>
        </div>
        {products["sub_categories"] && products["sub_categories"].length > 0 && (
          <Tab.Container className="scrollbar-tabs" activeKey={activeKey}>
            <div className="d-flex">
              {scrollable && (
                <div
                  className="d-flex align-items-center"
                  onClick={() =>
                    (scroller.current.scrollLeft -=
                      (scroller.current.clientWidth * 3) / 4)
                  }
                >
                  <FaChevronLeft size={20} color="#ac8d30" />
                </div>
              )}
              <Nav
                variant="tabs"
                className="sub-category-tabs"
                ref={scroller}
                scroll-behavior="smooth"
                style={{ scrollBehavior: "smooth" }}
              >
                {products["sub_categories"].map((element, index) => (
                  <Nav.Item
                    key={`sub-cat-nav-${index}`}
                    id={`sub-cat-nav-${index}`}
                  >
                    <Nav.Link
                      onClick={() => {
                        setActiveKey(element);
                        const retval = isInViewport(`sub-cat-nav-${index}`);
                        if (retval === 1) {
                          scroller.current.scrollLeft +=
                            (scroller.current.clientWidth * 3) / 4;
                        } else if (retval === 2) {
                          scroller.current.scrollLeft -=
                            (scroller.current.clientWidth * 3) / 4;
                        }
                      }}
                      eventKey={element}
                      title={element}
                      key={element + "-header"}
                    >
                      {element}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              {scrollable && (
                <div
                  className="d-flex align-items-center"
                  onClick={() =>
                    (scroller.current.scrollLeft +=
                      (scroller.current.clientWidth * 3) / 4)
                  }
                >
                  <FaChevronRight size={20} color="#ac8d30" />
                </div>
              )}
            </div>
            {products["sub_categories"].map((element, index) => (
              <Tab.Content
                key={`${element}-${index}`}
                onMouseDown={handleDesktopSwipStart}
                onTouchStart={handleMobileSwipStart}
                onMouseUp={(event) => handleDesktopSwipEnd(event, index)}
                onTouchEnd={(event) => handleMobileSwipEnd(event, index)}
              >
                <Tab.Pane eventKey={element}>
                  <ListGroup className="p-0 products">
                    <ListGroup.Item>
                      {products["products"][element] &&
                        products["products"][element].length > 0 &&
                        products["products"][element].map((product, i) => (
                          <>
                            <ProductRow
                              key={i}
                              cart={cart}
                              product={product}
                              addToCart={addToCart}
                              isMobile={isMobile}
                              showPriceValue={showPriceValue}
                            />
                            <hr className="sep-3" key={`sep-${i}`} />
                          </>
                        ))}
                    </ListGroup.Item>
                  </ListGroup>
                </Tab.Pane>
              </Tab.Content>
            ))}
          </Tab.Container>
        )}
      </Modal.Body>
    </Modal>
  );
}
